import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-482166c2")

_pushScopeId("data-v-482166c2")
const _hoisted_1 = {
  "data-testid": "adjust-stt-product-type-section",
  class: "bg-white flex flex-col gap-3 rounded-xl p-3"
}
const _hoisted_2 = { class: "flex flex-col gap-1" }
const _hoisted_3 = { class: "flex justify-between items-center" }
const _hoisted_4 = { class: "text-base font-bold text-black-lp-300" }
const _hoisted_5 = {
  key: 0,
  class: "flex flex-row gap-2 items-center"
}
const _hoisted_6 = { class: "text-xs font-semibold text-black-lp-100" }
const _hoisted_7 = { class: "flex gap-1 items-center text-12px text-gray-lp-600" }
const _hoisted_8 = { class: "text-12px" }
const _hoisted_9 = { class: "font-normal" }
const _hoisted_10 = {
  key: 0,
  class: "h-full w-full grid grid-cols-5 gap-2.5 place-content-start"
}
const _hoisted_11 = {
  key: 1,
  class: "h-96 flex items-center justify-center"
}
const _hoisted_12 = { class: "p-3 text-center" }
const _hoisted_13 = { class: "text-14px text-gray-lp-300 font-semibold" }
const _hoisted_14 = { class: "text-12px text-gray-lp-300 mt-2" }
const _hoisted_15 = { class: "p-3 flex flex-row items-center justify-center" }
const _hoisted_16 = {
  key: 2,
  class: "product-container h-full w-full grid grid-cols-5 gap-2.5 place-content-start"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ToggleV2 = _resolveComponent("ToggleV2")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_ProductCard = _resolveComponent("ProductCard")!

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", null, [
          _createVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("bookingV4.product.title")), 1)
        ]),
        (_ctx.showAgentDiscountToggle)
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("bookingV4.product.discountAgent")), 1),
              _createVNode(_component_ToggleV2, {
                "data-testid": "booking-v4-jenis-pengiriman-toggle-diskon-agen",
                "custom-label": "",
                height: "20px",
                "model-value": _ctx.agentDiscountRevealed,
                disabled: !_ctx.agentDiscountToggleEnabled,
                "onUpdate:modelValue": _ctx.onToggleAgentDiscount
              }, null, 8, ["model-value", "disabled", "onUpdate:modelValue"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode("span", _hoisted_8, [
          _createTextVNode(_toDisplayString(_ctx.$t("bookingV4.product.infoPrice")) + " ", 1),
          _createVNode("b", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onOpenTooltip($event))),
            onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onOpenTooltip($event))),
            class: "underline cursor-pointer"
          }, _toDisplayString(_ctx.$t("bookingV4.product.otherPrice")), 33),
          _createTextVNode(_toDisplayString(_ctx.$t("bookingV4.product.infoTariff")), 1)
        ]),
        _createVNode(_component_OverlayPanel, {
          ref: "openTooltip",
          appendTo: "body",
          style: _ctx.tooltipStyle
        }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_9, [
              _createVNode("div", null, _toDisplayString(_ctx.$t("bookingV4.product.tooltip.title")), 1),
              _createVNode("div", {
                innerHTML: _ctx.$t('bookingV4.product.tooltip.priceMsg')
              }, null, 8, ["innerHTML"])
            ])
          ]),
          _: 1
        }, 8, ["style"])
      ])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock("div", _hoisted_10, [
          (_openBlock(), _createBlock(_Fragment, null, _renderList(10, (n) => {
            return _createVNode(_component_Skeleton, {
              key: n,
              width: "100%",
              height: "132px"
            })
          }), 64))
        ]))
      : (_ctx.isError)
        ? (_openBlock(), _createBlock("div", _hoisted_11, [
            _createVNode("div", null, [
              _createVNode("div", _hoisted_12, [
                _createVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("bookingV4.product.error.title")), 1),
                _createVNode("p", _hoisted_14, _toDisplayString(_ctx.$t("bookingV4.product.error.subtitle")), 1)
              ]),
              _createVNode("div", _hoisted_15, [
                _createVNode("button", {
                  type: "button",
                  "data-testid": "booking-v4-jenis-pengiriman-button-retry",
                  class: "text-white bg-red-lp-100 rounded-md px-3 py-2 text-sm font-semibold",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('retry')))
                }, _toDisplayString(_ctx.$t("bookingV4.product.error.retry")), 1)
              ])
            ])
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_16, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.products, (item) => {
              return (_openBlock(), _createBlock(_component_ProductCard, {
                key: item.productType,
                product: item,
                selected: _ctx.modelValue === item.productType,
                "agent-discount-revealed": _ctx.agentDiscountRevealed,
                isNoRecommendation: _ctx.isNoRecommendation,
                showAgentDiscountToggle: _ctx.showAgentDiscountToggle,
                isClient: _ctx.isClient,
                "hide-discount": _ctx.hideDiscount,
                "group-name": _ctx.radioGroupName,
                "disable-selection": 
          _ctx.disabledProductType && _ctx.modelValue !== item.productType
        ,
                "hide-price": _ctx.hideTariff,
                currencyPrefix: _ctx.currencyPrefix,
                onSelect: _ctx.onSelectProduct
              }, null, 8, ["product", "selected", "agent-discount-revealed", "isNoRecommendation", "showAgentDiscountToggle", "isClient", "hide-discount", "group-name", "disable-selection", "hide-price", "currencyPrefix", "onSelect"]))
            }), 128))
          ]))
  ]))
})